import globalCacheManager from './globalCacheManager';

const CACHE_KEY = 'uom';
const STORAGE_KEY = 'inventory_uom_list_cache';

const loadCacheFromStorage = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) return null;
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

const saveCacheToStorage = (data) => {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // ignore
  }
};

class UomCache {
  constructor() {
    this.data = loadCacheFromStorage();
    this.pendingPromise = null;
    this.lastFetchTime = null;
  }

  async fetchData(forceRefresh = false) {
    if (globalCacheManager.isRefreshing) {
      return this.data || [];
    }

    if (!forceRefresh && this.data) {
      return this.data;
    }

    if (this.pendingPromise && !forceRefresh) {
      return this.pendingPromise;
    }

    this.pendingPromise = (async () => {
      try {
        await globalCacheManager.refreshFromBundle(forceRefresh);
        return this.data || [];
      } catch (error) {
        console.error('[UomCache] Error refreshing from bundle:', error);
        return this.data || [];
      } finally {
        this.pendingPromise = null;
      }
    })();

    return this.pendingPromise;
  }

  getData() {
    return this.data;
  }

  setData(data) {
    this.data = data || [];
    this.lastFetchTime = Date.now();
    saveCacheToStorage(this.data);
  }

  invalidate() {
    this.data = null;
    this.pendingPromise = null;
    this.lastFetchTime = null;
    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.removeItem(STORAGE_KEY);
    }
  }

  getLastFetchTime() {
    return this.lastFetchTime;
  }
}

const uomCacheInstance = new UomCache();

globalCacheManager.register(CACHE_KEY, uomCacheInstance);

export const fetchUomListCached = async (forceRefresh = false) => {
  return await uomCacheInstance.fetchData(forceRefresh);
};

export const getUomListCached = () => {
  return uomCacheInstance.getData();
};

export const invalidateUomCache = () => {
  uomCacheInstance.invalidate();
};

export default uomCacheInstance;
